import React, { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { superBatchGroupModulesSelector } from 'features/satManagement';
import styles from './BatchDetailsTableRow.module.scss';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';
import SuperBatchSelect from 'components/SuperBatchSelect';
import SaveBatchDetailButton from 'pages/SaveBatchDetailButton';

function BatchDetailsTableRow({ submission }) {
  const {
    id: timingId,
    name: timingIdName,
    batch_preference: batchPreference,
    course_assessment_batch_associations: batchAssociations,
  } = submission;
  const { name: bathcPreferenceName } = batchPreference || {};
  const { associate } = batchAssociations[0] || [];
  const { name: superBatchName, id: superBatchId } = associate || {};
  const selectedSuperBatch = useSelector(superBatchGroupModulesSelector);
  const [data, setData] = useState({});
  const [superBatches, setSuperBatches] = useState([]);

  const handleOnChange = useCallback(
    (newBatch) => {
      setSuperBatches(newBatch);
      setData({
        ...data,
        batch_timing_id: timingId,
        associate_super_batch_id: newBatch?.id,
      });
    },
    [data, timingId]
  );

  useEffect(() => {
    if (superBatchId) {
      setSuperBatches({
        value: superBatchName,
        label: superBatchName,
        id: superBatchId,
      });
    }
  }, [superBatchId, superBatchName]);

  return (
    <TableRow className={styles.root}>
      <TableCell className={styles.rowCell}>{bathcPreferenceName}</TableCell>
      <TableCell className={styles.rowCell}>{timingIdName}</TableCell>
      <TableCell>
        <SuperBatchSelect
          value={superBatches}
          onChange={handleOnChange}
          superBatchGroupId={selectedSuperBatch?.id}
        />
      </TableCell>
      <TableCell>
        <SaveBatchDetailButton data={data} />
      </TableCell>
    </TableRow>
  );
}

export default BatchDetailsTableRow;
